import { Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Edit } from '@mui/icons-material';
import { Stack } from '@mui/material';
import { withTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { openRequestModal } from '../../actions/modals';
import '../../layout/Dash/Dash.css';
import ModelService from '../../services/models.service';
import StudentsService from '../../services/students.service';
import ComponentTable from '../ComponentTable';
import BooksSearch from './BooksSearch';
import ParseMobilePhones from './ParceMobilePhones';

const DashSupportView = ({ t, openRequestModal, ...props }) => {
    const actions = [
        {
            title: t('modals_name.edit'),
            onClick: id =>
                openRequestModal({
                    opened: true,
                    data: {
                        id: id,
                        modaltype: 'EditUserModal',
                        header: t('modals_name.edit'),
                    },
                }),
            Icon: Edit,
        },
    ];
    const route = useLocation();
    const pathname = route.pathname;
    const hiddePart = pathname === '/dashboard/hidden';
    return (
        <Fragment>
            <Stack spacing={2}>
                {hiddePart ? (
                    <ParseMobilePhones />
                ) : (
                    <>
                        <BooksSearch />

                        <ComponentTable
                            source={{
                                getData: (page, size, sort, filter) =>
                                    StudentsService.SupportList(false, {
                                        page: page || 0,
                                        size,
                                        orderBy: (sort && sort.orderBy) || null,
                                        order: (sort && sort.order) || null,
                                        filter,
                                    }),
                                getModel: () => ModelService.SupportModels(false),
                            }}
                            actions={actions}
                            enableFilter
                            fetchOnFilter
                            title={t('table.users_list')}
                            enableSettings
                            toolbarvisible={true}
                            headerTable={'Support'}
                            typeTable={'Support'}
                        />
                    </>
                )}
            </Stack>
        </Fragment>
    );
};

const widthConnect = connect(
    state => ({
        user: state.user,
        cities: state.cities,
        offices: state.offices,
    }),
    dispatch => bindActionCreators({ openRequestModal }, dispatch)
);

export default withTranslation()(widthConnect(DashSupportView));
